import React from "react";
import {
  CONTACT_FOLLOW_UP_STATUS_NONE,
  getContactFollowUpStatus,
  getContactFollowUpStatusBadgeStyle,
  getContactFollowUpStatusLabel,
} from "../shared/utils/participantContactLog";

/**
 * Compact status badge for contact-note follow-ups (Overdue / Due today / Upcoming / Done).
 */
export default function ContactFollowUpStatusBadge({ log, status: statusProp }) {
  const status = statusProp || getContactFollowUpStatus(log);
  if (!status || status === CONTACT_FOLLOW_UP_STATUS_NONE) return null;
  const label = getContactFollowUpStatusLabel(status);
  const style = getContactFollowUpStatusBadgeStyle(status);
  if (!label || !style) return null;
  return (
    <span className="badge" style={style}>
      {label}
    </span>
  );
}
